"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetGroupObjectives = void 0;
const react_query_1 = require("react-query");
const adminClient_1 = require("client/adminClient");
const groupObjectivesKeys_1 = __importDefault(require("consts/queryKeys/groupObjectivesKeys"));
const useGetGroupObjectives = (page, group, options) => {
    return (0, react_query_1.useInfiniteQuery)(groupObjectivesKeys_1.default.group(page, group), ({ pageParam }) => (0, adminClient_1.getPlacementInfo)(group, pageParam), Object.assign({ getNextPageParam: (data) => {
            var _a, _b, _c;
            const nextOffset = ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.pagination) === null || _c === void 0 ? void 0 : _c.nextOffset) || null;
            return { offset: nextOffset };
        } }, options));
};
exports.useGetGroupObjectives = useGetGroupObjectives;
